const map = {
	"./ModuleAiTools/AiVideoGenerator/registry/modal.js": 84610,
	"./ModuleCommunity/Course/registry/modal.js": 39851,
	"./ModuleCommunity/CourseLesson/registry/modal.js": 65255,
	"./ModuleCommunity/CourseReview/registry/modal.js": 81623,
	"./ModuleCommunity/CourseStudent/registry/modal.js": 79382,
	"./ModuleCommunity/FeaturedContent/registry/modal.js": 10119,
	"./ModuleCompany/BCBusinessSector/registry/modal.js": 13103,
	"./ModuleCompany/BCEconomicSector/registry/modal.js": 95630,
	"./ModuleCompany/BCIndustry/registry/modal.js": 25925,
	"./ModuleCompany/BCIndustryActivity/registry/modal.js": 98798,
	"./ModuleCompany/BCIndustryGroup/registry/modal.js": 872,
	"./ModuleCompany/Company/registry/modal.js": 98209,
	"./ModuleCompany/ExtractFinanceStatement/registry/modal.js": 59770,
	"./ModuleCompany/GoldExchange/registry/modal.js": 1407,
	"./ModuleCompany/GoldSnapshot/registry/modal.js": 7128,
	"./ModuleCompany/NewsArticle/registry/modal.js": 86089,
	"./ModuleCompany/NewsSummary/registry/modal.js": 50891,
	"./ModuleCompany/PromptGenAi/registry/modal.js": 70510,
	"./ModuleCompany/SeIndexSnapshot/registry/modal.js": 65140,
	"./ModuleCompany/StockAnalysisReport/registry/modal.js": 82002,
	"./ModuleCore/AppReleaseNotices/registry/modal.js": 29341,
	"./ModuleCore/Billing/registry/modal.js": 15880,
	"./ModuleCore/BillingDetail/registry/modal.js": 11024,
	"./ModuleCore/BillingTransaction/registry/modal.js": 28547,
	"./ModuleCore/ConfigSystem/registry/modal.js": 63041,
	"./ModuleCore/ContactForm/registry/modal.js": 96636,
	"./ModuleCore/GlobalConfig/registry/modal.js": 59183,
	"./ModuleCore/IntegrationLog/registry/modal.js": 86004,
	"./ModuleCore/MembershipCashPlan/registry/modal.js": 75712,
	"./ModuleCore/MembershipPlan/registry/modal.js": 90289,
	"./ModuleCore/MembershipPlanUser/registry/modal.js": 18836,
	"./ModuleCore/MembershipSubscriptionUser/registry/modal.js": 49458,
	"./ModuleCore/MiniAppConfig/registry/modal.js": 5282,
	"./ModuleCore/Order/registry/modal.js": 53702,
	"./ModuleCore/PaymentMode/registry/modal.js": 66201,
	"./ModuleCore/PromotionCoupon/registry/modal.js": 2811,
	"./ModuleCore/PromotionCouponRedemption/registry/modal.js": 86732,
	"./ModuleCore/PromotionRule/registry/modal.js": 98811,
	"./ModuleCore/ReferralRegistration/registry/modal.js": 42012,
	"./ModuleCore/ReferralReward/registry/modal.js": 27926,
	"./ModuleCore/ReferralTransition/registry/modal.js": 61258,
	"./ModuleCore/ReferralWithdrawal/registry/modal.js": 72550,
	"./ModuleCore/ReferrerRewardPlan/registry/modal.js": 69329,
	"./ModuleCore/SecuritiesAccount/registry/modal.js": 5961,
	"./ModuleCore/SecuritiesAccountForm/registry/modal.js": 43263,
	"./ModuleCore/SecuritiesSubAccount/registry/modal.js": 73613,
	"./ModuleCore/Tenant/registry/modal.js": 78792,
	"./ModuleCore/TenantUserMapping/registry/modal.js": 63507,
	"./ModuleCore/User/registry/modal.js": 77189,
	"./ModuleCore/UserCash/registry/modal.js": 70040,
	"./ModuleCore/UserCashDetail/registry/modal.js": 76387,
	"./ModuleCore/UserCashPlan/registry/modal.js": 47989,
	"./ModuleCore/UserCashTransaction/registry/modal.js": 13802,
	"./ModuleCore/UserForceSession/registry/modal.js": 90498,
	"./ModuleCore/UserLoginActivity/registry/modal.js": 60145,
	"./ModuleCore/UserReferral/registry/modal.js": 1226,
	"./ModuleCore/UserReferralPlan/registry/modal.js": 77275,
	"./ModuleCore/UserReferralReward/registry/modal.js": 69715,
	"./ModuleCrm/CampaignSale/registry/modal.js": 19738,
	"./ModuleCrm/CampaignZone/registry/modal.js": 41257,
	"./ModuleCrm/CompanyReport/registry/modal.js": 50398,
	"./ModuleCrm/ContentTemplate/registry/modal.js": 4988,
	"./ModuleCrm/CustomField/registry/modal.js": 1314,
	"./ModuleCrm/PopupInfo/registry/modal.js": 4004,
	"./ModuleCrm/PopupUser/registry/modal.js": 35198,
	"./ModuleCrm/SegmentUser/registry/modal.js": 7935,
	"./ModuleCrm/Segments/registry/modal.js": 43855,
	"./ModuleCrm/TagUser/registry/modal.js": 9560,
	"./ModuleCrm/Tags/registry/modal.js": 97418,
	"./ModuleCrm/UserFeedback/registry/modal.js": 43533,
	"./ModuleCrm/UserInfo/registry/modal.js": 10848,
	"./ModuleCrm/WallOfLove/registry/modal.js": 12142,
	"./ModuleCrm/WorkflowTrigger/registry/modal.js": 82696,
	"./ModuleCrm/WorkflowTriggerUser/registry/modal.js": 26789,
	"./ModuleCrm/Zone/registry/modal.js": 37939,
	"./ModuleNotification/NotificationModule/registry/modal.js": 70921,
	"./ModuleNotification/NotificationMsgTemplate/registry/modal.js": 47496,
	"./ModuleNotification/NotificationSetting/registry/modal.js": 67033,
	"./ModuleNotification/NotificationSnapshot/registry/modal.js": 26969,
	"./ModuleNotification/NotificationType/registry/modal.js": 95013,
	"./ModuleNotification/NotificationTypeGroup/registry/modal.js": 11208,
	"./ModuleNotification/OtpTracking/registry/modal.js": 51650,
	"./ModuleNotification/SmSubscribeTracking/registry/modal.js": 84085,
	"./ModuleNotification/SmsTrackingLog/registry/modal.js": 634,
	"./ModulePersonalize/CompanyNote/registry/modal.js": 10474,
	"./ModulePersonalize/IntegrationLog/registry/modal.js": 86163,
	"./ModulePersonalize/NebulaBrainDailyTrade/registry/modal.js": 29743,
	"./ModulePersonalize/NebulaBrainHistory/registry/modal.js": 82290,
	"./ModulePersonalize/NebulaDecisionTemplates/registry/modal.js": 58995,
	"./ModulePersonalize/NebulaDecisions/registry/modal.js": 54681,
	"./ModulePersonalize/NebulaHoldings/registry/modal.js": 67238,
	"./ModulePersonalize/NebulaManagementFee/registry/modal.js": 80895,
	"./ModulePersonalize/NebulaMetadata/registry/modal.js": 18777,
	"./ModulePersonalize/NebulaOrders/registry/modal.js": 64741,
	"./ModulePersonalize/NebulaPerfFeeAmortized/registry/modal.js": 13650,
	"./ModulePersonalize/NebulaPerformance/registry/modal.js": 37182,
	"./ModulePersonalize/NebulaPerformanceFee/registry/modal.js": 29104,
	"./ModulePersonalize/NebulaPerformanceLog/registry/modal.js": 40606,
	"./ModulePersonalize/NebulaPositions/registry/modal.js": 71188,
	"./ModulePersonalize/NebulaProfile/registry/modal.js": 81867,
	"./ModulePersonalize/NebulaRewardTransaction/registry/modal.js": 44171,
	"./ModulePersonalize/NebulaStatistics/registry/modal.js": 43119,
	"./ModulePersonalize/NebulaTradingTransaction/registry/modal.js": 27967,
	"./ModulePersonalize/NebulaTransactions/registry/modal.js": 26853,
	"./ModulePersonalize/NebulaUltraFees/registry/modal.js": 60841,
	"./ModulePersonalize/NebulaUltraLog/registry/modal.js": 13698,
	"./ModulePersonalize/NebulaUltraMetadata/registry/modal.js": 82049,
	"./ModulePersonalize/NebulaUltraPlan/registry/modal.js": 76403,
	"./ModulePersonalize/NebulaUltraTransactions/registry/modal.js": 4989,
	"./ModulePersonalize/NebulaUserProfile/registry/modal.js": 64008,
	"./ModulePersonalize/NebulaUserProfileHistory/registry/modal.js": 4030,
	"./ModulePersonalize/PnlConfigSystem/registry/modal.js": 26396,
	"./ModulePersonalize/PortfolioList/registry/modal.js": 51579,
	"./ModulePersonalize/PortfolioStock/registry/modal.js": 91213,
	"./ModulePersonalize/PortfolioSub/registry/modal.js": 76241,
	"./ModulePersonalize/PortfolioWallet/registry/modal.js": 18892,
	"./ModulePersonalize/PortfolioWalletMarginHistory/registry/modal.js": 34716,
	"./ModulePersonalize/TaIndicatorConfig/registry/modal.js": 11689,
	"./ModulePersonalize/TaSignalConfig/registry/modal.js": 14468,
	"./ModulePersonalize/UserScreener/registry/modal.js": 455,
	"./ModulePersonalize/UserScreenerClient/registry/modal.js": 29086,
	"./ModulePersonalize/UserWorkspace/registry/modal.js": 29251,
	"./ModulePersonalize/Watchlist/registry/modal.js": 3126,
	"./ModulePersonalize/WatchlistItem/registry/modal.js": 58455,
	"./ModuleRole/Permission/registry/modal.js": 96702,
	"./ModuleRole/PermissionGroup/registry/modal.js": 86561,
	"./ModuleRole/PermissionGroupMapping/registry/modal.js": 5407,
	"./ModuleRole/PermissionGroupUser/registry/modal.js": 9764,
	"./ModuleRole/UserAuthority/registry/modal.js": 43223,
	"./ModuleRole/UserAuthorityMapping/registry/modal.js": 90393,
	"./ModuleSearch/WidgetDocumentSearch/registry/modal.js": 45224
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91801;